<template>
	<JBox>
		<JBox class="s-mx-auto s-max-w-4xl s-pt-10">
			<AppInfo />
		</JBox>
	</JBox>
</template>

<script>
import AppInfo from "../components/AppInfo"

export default {
	components: { AppInfo },

	props: {
		// From router
		appId: {
			type: String
		}
	},

	methods: {
		async fetchApp() {
			const { isSuccess } = await this.$store.dispatch("apps/readApp", { appId: this.appId })
			if (!isSuccess) this.$router.push({ name: "ViewAppsHome" })
		}
	},

	mounted() {
		this.fetchApp()
	}
}
</script>
